import { useEffect, useState, useCallback } from "react";
import { useLocation } from "react-router-dom";
import { api } from "./api";

// Auto-registers a study "day activity" whenever the user visits any /study route.
// Returns any milestones just unlocked (parent can show a celebratory modal).
export function useStreakPinger(user, setUser) {
  const loc = useLocation();
  const [justUnlocked, setJustUnlocked] = useState([]);

  useEffect(() => {
    if (!user) return;
    if (!loc.pathname.startsWith("/study")) return;
    if (user.streak?.today_logged) return;
    api.post("/streak/ping").then((r) => {
      setUser?.((prev) => (prev ? { ...prev, streak: { ...(prev.streak || {}), ...r.data } } : prev));
      if (r.data?.just_unlocked?.length) {
        setJustUnlocked((q) => [...q, ...r.data.just_unlocked]);
      }
    }).catch(() => {});
  }, [loc.pathname, user, setUser]);

  const clearOne = useCallback(() => setJustUnlocked((q) => q.slice(1)), []);
  return { justUnlocked, clearOne };
}
